import React from 'react';
import Card from '../components/Card';
import Filters from '../components/Filters';
import { useFavorites } from '../context/FavoritesContext';
import { RouteComponentProps } from 'react-router-dom';
import TagsHoc from '../components/hoc/TagsHoc';
import { useQueryStrings } from '../context/QueryStringContext';
import { useData } from '../context/DataContext';
import { getOptimizedEdpImageUrl } from '../../../../../../../shared/lib/image';
import { useApp } from '../context/AppContext';
import { addDaysToIsoDate, getLocaleDateStringFromIso } from '../../../../../../../shared/lib/time';

interface BookmarkPagePropsBase {}

type BookmarkPageProps = BookmarkPagePropsBase & RouteComponentProps;

function BookmarksPage(_props: BookmarkPageProps) {
  const { config } = useApp();
  const { data } = useData();
  const { favorites, toggleFavorite } = useFavorites();
  const { updateQs } = useQueryStrings();

  const today = config.date;
  const tomorrow = addDaysToIsoDate(today, 1);

  const sections = [];

  if (Object.keys(favorites.events).length > 0) {
    sections.push(
      <div>
        {/* <h2 className="text-xl font-semibold ml-4 my-3">{data.appConfig.LINEUP_LABEL}</h2> */}
        <div className="grid gap-2">
          {Object.values(favorites.events).map(evt => {
            return (
              <TagsHoc type="event" item={evt} key={evt.id}>
                {props => (
                  <Card
                    className="border-b"
                    onClick={() => updateQs('event', evt.id)}
                    title={evt.title}
                    subtitle={[
                      evt.venueString,
                      `${
                        evt.date === today
                          ? data.appConfig.TODAY_LABEL
                          : evt.date === tomorrow
                            ? data.appConfig.TOMORROW_LABEL
                            : getLocaleDateStringFromIso(evt.date, {
                                month: 'short',
                                day: 'numeric',
                                weekday: 'short',
                              })
                      }, ${evt.timeString}`,
                    ]}
                    image={getOptimizedEdpImageUrl(
                      evt.images,
                      evt.imageOptimizations,
                      config.imgRequirements,
                      0
                    )}
                    tags={props.tags}
                    isFavorite
                    onFavoriteClick={() => toggleFavorite({ type: 'events', value: evt })}
                  />
                )}
              </TagsHoc>
            );
          })}
        </div>
      </div>
    );
  }

  if (Object.keys(favorites.venues).length > 0) {
    sections.push(
      <div>
        {/* <h2 className="text-xl font-semibold ml-4 my-3">{data.appConfig.EXPLORE_LABEL}</h2> */}
        <div className="grid gap-2">
          {Object.values(favorites.venues).map(venue => {
            return (
              <TagsHoc type="venue" item={venue} key={venue.templateId}>
                {props => (
                  <Card
                    className="border-b"
                    onClick={() => updateQs('venue', venue.templateId)}
                    title={venue.venueString}
                    subtitle={venue.timeStrings}
                    image={getOptimizedEdpImageUrl(
                      venue.images,
                      venue.imageOptimizations,
                      config.imgRequirements,
                      0
                    )}
                    tags={props.tags}
                    isFavorite
                    onFavoriteClick={() => toggleFavorite({ type: 'venues', value: venue })}
                  />
                )}
              </TagsHoc>
            );
          })}
        </div>
      </div>
    );
  }

  if (Object.keys(favorites.offers).length > 0) {
    sections.push(
      <div>
        {/* <h2 className="text-xl font-semibold ml-4 my-3">{data.appConfig.OFFERS_LABEL}</h2> */}
        <div className="grid gap-2">
          {Object.values(favorites.offers).map(offer => {
            return (
              <TagsHoc type="basic" item={offer} key={offer.id}>
                {props => (
                  <Card
                    className="border-b"
                    onClick={() => updateQs('offer', offer.id)}
                    title={offer.title}
                    subtitle={offer.description}
                    image={getOptimizedEdpImageUrl(
                      offer.images,
                      offer.imageOptimizations,
                      config.imgRequirements,
                      0
                    )}
                    tags={props.tags}
                    isFavorite
                    onFavoriteClick={() => toggleFavorite({ type: 'offers', value: offer })}
                  />
                )}
              </TagsHoc>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <div id="BookmarksPage">
      <Filters title={data.appConfig.FAVORITES_LABEL} icon={['far', 'heart']} />
      <div className="grid gap-2 pb-8">
        {sections.length > 0 ? (
          sections
        ) : (
          <div className="italic text-slate px-4 pt-4 text-center">
            {data.appConfig.NO_FAVORITES_TEXT}
          </div>
        )}
      </div>
    </div>
  );
}

export default BookmarksPage;
